import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import en from './locales/en';
import fr from './locales/fr';

// Keep lightweight plugins
const timezone = require('dayjs/plugin/timezone');
dayjs.extend(timezone);
const relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);

// Detect language from URL path before initialization
const getLanguageFromPath = () => {
  if (typeof window !== 'undefined' && window.location) {
    const path = window.location.pathname;
    if (path.startsWith('/fr')) return 'fr';
    if (path.startsWith('/en')) return 'en';
  }
  return null;
};

const pathLang = getLanguageFromPath();
const detectedLang = pathLang || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: detectedLang,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'seo', 'header'],
    resources: {
      en: {
        common: en.common,
        seo: en.seo,
        header: en.header
      },
      fr: {
        common: fr.common,
        seo: fr.seo,
        header: fr.header
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

// Update dayjs locale when language changes
i18n.on('languageChanged', (lng) => {
  if (lng === 'fr') {
    import(/* webpackChunkName: "dayjs-locale-fr" */ 'dayjs/locale/fr').then(() => {
      dayjs.locale('fr');
    });
  } else {
    dayjs.locale('en');
  }
});

// Set initial dayjs locale
if (detectedLang === 'fr') {
  import(/* webpackChunkName: "dayjs-locale-fr" */ 'dayjs/locale/fr').then(() => {
    dayjs.locale('fr');
  });
} else {
  dayjs.locale('en');
}

export default i18n;
